export default "__VITE_ASSET__zB0X09BE__"